import React, { useRef } from 'react'
import styels from './FirstBg.module.css'
import BG from '../../asssists/FBG.mp4'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
export default function FirstBg() {

  let container = useRef();
  let words = useRef();
 useGSAP(() => {
   gsap.fromTo(words.current, {
    opacity: 0,
    y: 200,
    stagger: 0.2,
    delay: 3
   }, {
    opacity: 1,
    y: 0,
    stagger: 0.5,
    duration: 3,
    delay: 3
     }
     
    )
 },{scope:container})


  return (
    <>
   <section ref={container} className={styels.firstBg}>
   <video src={BG} muted loop autoPlay alt="" className={styels.vid}></video>
   <div className="container">
   <div className="row">
   <div className="col-md-12">
  
   <div className={styels.arrow}>
   <i onClick={() => window.scrollTo(0, 910)} className="fa-solid fa-angles-down fa-2x text-danger"></i>
   </div>  
   </div>
   </div>
   </div>
 
   </section>   
    </>
  )
}
